// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5977) return "js/chunk.npm-async-core-js.86292c46.js";
	if (chunkId === 230) return "js/chunk.npm-async-intl-segmenter-polyfill-rs.dd6f9d91.js";
	if (chunkId === 6902) return "js/chunk.npm-async-@dotlottie.72ae786f.js";
	if (chunkId === 2107) return "js/chunk.npm-async-@blocksuite.8cf3b216.js";
	if (chunkId === 1006) return "js/chunk.npm-async-pdf-lib.3734e3e8.js";
	if (chunkId === 2394) return "js/chunk.npm-async-@pdf-lib.28f82ba4.js";
	if (chunkId === 8385) return "js/chunk.npm-async-pako.4b435e37.js";
	if (chunkId === 8772) return "js/chunk.npm-async-shiki.c0b66585.js";
	if (chunkId === 1571) return "js/chunk.npm-async-mermaid.713693c9.js";
	if (chunkId === 7966) return "js/chunk.npm-async-dagre-d3-es.a5beb1d6.js";
	if (chunkId === 4922) return "js/chunk.npm-async-lodash-es.7833eff1.js";
	if (chunkId === 96) return "js/chunk.npm-async-khroma.89aeffdd.js";
	if (chunkId === 6929) return "js/chunk.npm-async-dayjs.ca9d217e.js";
	if (chunkId === 7673) return "js/chunk.npm-async-elkjs.1048c162.js";
	if (chunkId === 9809) return "js/chunk.npm-async-cytoscape.e8145207.js";
	if (chunkId === 1342) return "js/chunk.npm-async-layout-base.a37cb8fc.js";
	if (chunkId === 5984) return "js/chunk.npm-async-cytoscape-cose-bilkent.e9af828d.js";
	if (chunkId === 7538) return "js/chunk.npm-async-cose-base.c2de3c96.js";
	if (chunkId === 1249) return "js/chunk.npm-async-d3-sankey.9bf2626b.js";
	if (chunkId === 9497) return "js/chunk.npm-async-d3-shape.a8eb93d6.js";
	if (chunkId === 4096) return "js/chunk.npm-async-@lottiefiles.33957b7d.js";
	if (chunkId === 9296) return "js/chunk.9296.04204087.js";
	if (chunkId === 7719) return "js/chunk.7719.521d1ed2.js";
	if (chunkId === 5725) return "js/chunk.5725.4821a346.js";
	if (chunkId === 6323) return "js/chunk.6323.f5c9288a.js";
	if (chunkId === 1817) return "js/chunk.1817.a4fb30ba.js";
	if (chunkId === 5402) return "js/chunk.npm-async-@journeyapps.c348667a.js";
	if (chunkId === 4216) return "js/chunk.npm-async-bson.939815e0.js";
	if (chunkId === 8120) return "js/chunk.8120.922aff16.js";
	if (chunkId === 1133) return "js/chunk.1133.d015a7f4.js";
	if (chunkId === 328) return "js/chunk.328.c9cb213e.js";
	if (chunkId === 8335) return "js/chunk.app-async.9baef8ed.js";
	if (chunkId === 9465) return "js/chunk.npm-async-rxjs.e18db8d2.js";
	if (chunkId === 69) return "js/chunk.69.abcd2850.js";
	if (chunkId === 4595) return "js/chunk.4595.3ce0538e.js";
	if (chunkId === 819) return "js/chunk.819.e3341c15.js";
	if (chunkId === 6797) return "js/chunk.6797.9f1b9b97.js";
	if (chunkId === 3316) return "js/chunk.npm-async-lucide-react.bf699604.js";
	if (chunkId === 9167) return "js/chunk.9167.469d767e.js";
	if (chunkId === 518) return "js/chunk.518.c6ae2b47.js";
	if (chunkId === 7933) return "js/chunk.auth.ee01b910.js";
	if (chunkId === 9286) return "js/chunk.9286.bddc69f6.js";
	if (chunkId === 4555) return "js/chunk.4555.0d434b06.js";
	if (chunkId === 4145) return "js/chunk.4145.a160036e.js";
	if (chunkId === 4975) return "js/chunk.4975.89b25be5.js";
	if (chunkId === 4309) return "js/chunk.4309.9789b358.js";
	if (chunkId === 7956) return "js/chunk.7956.180cd2e6.js";
	if (chunkId === 1973) return "js/chunk.1973.2adc90dd.js";
	if (chunkId === 2389) return "js/chunk.2389.e271451f.js";
	if (chunkId === 5808) return "js/chunk.5808.2912df5d.js";
	if (chunkId === 6064) return "js/chunk.6064.83bb4fa5.js";
	if (chunkId === 6893) return "js/chunk.6893.bc996826.js";
	if (chunkId === 1400) return "js/chunk.1400.5001514e.js";
	if (chunkId === 6094) return "js/chunk.6094.c680879f.js";
	if (chunkId === 170) return "js/chunk.npm-async-swr.6e7fd87d.js";
	if (chunkId === 8270) return "js/chunk.8270.610e95b3.js";
	if (chunkId === 168) return "js/chunk.npm-async-react-dom.ec9b6358.js";
	if (chunkId === 4350) return "js/chunk.npm-async-@excalidraw.1fb38777.js";
	if (chunkId === 2099) return "js/chunk.npm-async-react-player.a6b694aa.js";
	if (chunkId === 7301) return "js/chunk.7301.becc4a0d.js";
	if (chunkId === 4444) return "js/chunk.4444.d0166f2e.js";
	if (chunkId === 2063) return "js/chunk.2063.c108a2b8.js";
	if (chunkId === 3941) return "js/worker.b2f819dd.js";
	// return url for filenames based on template
	return undefined;
};